module.exports = __webpack_public_path__ + "img/logoMedium.c878f55c.png";